<div class="noselect text-center ws-product-detail__total ws-product-detail__total--pieces">
  <span [translate]="'common.total'">Total</span>
  {{quantity}}
  <span [translate]="'cakeBuilder.footerSection.cakesQuantity'">stk</span>
  |
  <strong class="ws-product-detail__total-value">{{price | currencyFormat}}</strong>&nbsp;{{currency}}
</div>
